import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Suppress all console logs in production
// This ensures a clean console for end users
// Only enable if VITE_ENABLE_LOGGING is not explicitly set to 'true'
const enableLogging = import.meta.env.VITE_ENABLE_LOGGING === 'true';
if (!enableLogging && import.meta.env.PROD) {
  // Override all console methods to disable logging in production
  const noop = () => {};
  
  // Disable all console methods except error (for critical issues only)
  // Note: Vite's terser will also remove console.* calls during build,
  // but this provides an additional layer of protection
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  // Keep console.error for critical errors, but filter out HTTP errors
  const originalError = console.error;
  console.error = (...args: any[]) => {
    const message = args[0]?.toString() || '';
    // Filter out HTTP error logs (e.g., "DELETE http://... 400 (Bad Request)")
    const isHttpError = /^\s*(GET|POST|PUT|DELETE|PATCH)\s+https?:\/\/.*\s+\d{3}\s*\(/.test(message);
    // Filter out expected business logic errors
    const isExpectedError = message.includes('Cannot delete') || 
                           message.includes('Không thể xóa') ||
                           message.includes('đang được mượn');
    
    // Only log critical errors that are not HTTP errors or expected business logic errors
    if (!isHttpError && !isExpectedError) {
      originalError.apply(console, args);
    }
  };
  
  // Note: Browser DevTools Network tab will still show failed requests
  // This is expected behavior and cannot be completely suppressed
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
